<template>
  <div class="container">
    <div class="mt-4 mb-2 d-flex justify-content-between">
      <back-arrow :params="{operationId: operationId}" :title="$t('Operation.documents')" routeBack="OperationShow" :sub-title-ope="this.operationName"/>
      <div class="row mx-0 ml-auto align-items-center">
        <b-button class="btn-medium mr-2" variant="outline-primary" @click="clickOnAddFolderBtn">
          <folder-icon class="mr-1" size="18"/>
          {{ $t('Add') }} {{ $t('a') }} {{ $t('operation.dossier') }}
        </b-button>
        <b-button v-if="allowCreate" class="btn-medium" variant="primary" @click="clickOnCreateBtn">
          <plus-icon class="mr-1" size="18"/>
          {{ $t('Add') }} {{ $t('a') }} {{ $t('document') }}
        </b-button>
      </div>
    </div>

    <div>
      <div class="section-title">
        {{ $t("Folders") }}
      </div>
    </div>

    <div class="folder-grid mt-2">
      <div
        v-for="folder in folderMap.flat()"
        :key="folder.id"
        class="folder-card"
        :class="(selectedFolder === folder.id) ? 'folder-fixed-selected folder-title' : 'folder-fixed folder-title'"
        @click="filterByFolder(folder.id)"
      >
        <div class="folder-actions-top" v-if="!['Devis','Factures','Appel de fonds'].includes(folder.name)">
          <pencil-icon size="16" class="mr-1"
                       @click.stop="clickOnEditFolderBtn(folder)"
                       :class="{ 'text-white': selectedFolder == folder.id }"/>
          <trash-icon size="16" color="#9E0430"
                      @click.stop="clickOnDeleteFolderBtn(folder)"/>
        </div>

        <div class="folder-left">
          <div v-if="['Devis','Factures','Appel de fonds'].includes(folder.name)" class="mr-2">
            <img v-if="selectedFolder === folder.id"
                 :src="require(`@/assets/images/ic-folder-white.png`)" alt="folder" height="22" width="auto">
            <img v-else
                 :src="require(`@/assets/images/ic-folder-blue.png`)" alt="folder" height="22" width="auto">
          </div>
          <div v-else class="mr-2">
            <folder-icon size="22" :color="selectedFolder == folder.id ? '#FFFFFF':'#6D84C4'" />
          </div>
          <span class="folder-name" :class="{ 'text-white': selectedFolder == folder.id }">
        {{ folder.name }}
      </span>
        </div>
      </div>
    </div>


    <div class="mb-2 mt-4 d-flex justify-content-between">
      <div class="section-title">
        {{ $t("operation.general.documents") }}
      </div>
      <b-link class="ml-auto" @click="showAllLinks">
        <span class="main-color-text">{{ $t('operationDocument.Share.showAll') }}</span>
      </b-link>
    </div>

    <div class="border-grey">
      <b122-table
        ref="B122TableOperationDocument"
        :delete-item="allowDelete"
        :edit-item="allowEdit"
        :empty-button="$t('operationDocument.Add').toString()"
        :empty-text="$t('operationDocument.emptyText').toString()"
        :empty-title="$t('operationDocument.emptyTitle').toString()"
        :fields="tableFields"
        :get-b122-table-results-url="'/operationDocument/getB122TableResults?restrictbylong-operationFolderId=' + selectedFolder +'&restrictbylong-operationId=' + operationId"
        :init-b122-table-url="'/operationDocument/initB122Table?operationId=' + operationId"
        :select-all-action-title="$t('operationDocument.Share')"
        :use-filters="true"
        :use-pagination="true"
        identifier="TableOperationDocument"
        select-mode="multi"
        @add="clickOnCreateBtn"
        @clickOnDeleteBtn="clickOnDeleteDocumentBtn"
        @clickOnEditBtn="clickOnEditBtn"
        @onRowSelected="onRowSelected"
        @selectAllAction="shareDocuments"
        @setTotalCount="setTotalCount"
        @showAllLinks="showAllLinks">
        <template #cell(validity)="data">
          <div v-if="data.item.expirationDate == null">
            <file-check-icon v-if="data.item.folder === 'Devis' || data.item.folder === 'Factures'" class="main-color-text"
                             size="26"/>
            <span v-else>-</span>
          </div>
          <div v-else>
            <file-x-icon v-if="getExpiration(data.item.expirationDate)" class="main-red-color" size="26"></file-x-icon>
            <file-alert-icon v-else-if="getTimeBetweenTodayAndDate(data.item.expirationDate)"
                             class="main-yellow-color" size="26"/>
            <file-check-icon v-else class="main-color-text" size="26"/>
          </div>
        </template>

        <template #cell(actions)="row">
          <div class="actions-container text-right">
            <button class="mr-1 download-btn" @click=clickOnDownloadBtn(row)>
              <download-icon size="18"/>
            </button>
            <button v-if="row.item.folder !== 'Devis' && row.item.folder !== 'Factures' && row.item.folder !== 'Appel de fonds'" class="show-action-btn edit mr-1"
                    @click="clickOnEditBtn(row)">
              <pencil-icon size="18"/>
            </button>
            <button v-if="row.item.folder !== 'Devis' && row.item.folder !== 'Factures' && row.item.folder !== 'Appel de fonds'" class="show-action-btn delete"
                    @click="clickOnDeleteDocumentBtn(row)">
              <trash-icon size="18"/>
            </button>
          </div>
        </template>

      </b122-table>
    </div>

    <Item-delete-modal
      id="document-delete-modal"
      :beginsWithVoyel="false"
      :isFeminine="false"
      :selectedItem="selectedDocument"
      controllerName="operationDocument"
      itemSingularName="document"
      itemSingularNameUpp="Document"
      @didDeleteItem="didDeleteDocument()"/>

    <ShareDocumentsModal
      :documents="documentsToShare"
      :operation-id="operationId"/>

    <AddFolderModal
      :operation-id="operationId"
      @didAddFolder="didAddFolder()"/>

    <EditFolderModal
      :key="editFolderKey"
      :folder="editFolder"
      :operation-id="operationId"
      @didAddFolder="didAddFolder()"/>

    <delete-folder-modal
      :folder="deleteFolder"
      :operation-id="operationId"
      @didAddFolder="didAddFolder()">
    </delete-folder-modal>

  </div>
</template>

<script>

import B122Table from "../../../components/b122/B122Table";
import ItemDeleteModal from "../../../components/b122/ItemDeleteModal";
import BackArrow from "../../../components/b122/BackArrow.vue";
import ShareDocumentsModal from "../../operationBilan/components/ShareDocumentsModal.vue";
import AddFolderModal from "../components/AddFolderModal.vue";
import EditFolderModal from "../components/EditFolderModal.vue";
import DeleteFolderModal from "../components/DeleteFolderModal.vue";
import api from "../../../services/api";

export default {
  name: "OperationShowDocuments",

  components: {
    ShareDocumentsModal,
    BackArrow,
    B122Table,
    ItemDeleteModal,
    AddFolderModal,
    EditFolderModal,
    DeleteFolderModal
  },

  data() {
    return {
      editFolder: {},
      deleteFolder: {},
      selectedFolder: 0,
      editFolderKey: 0,
      mapLength: 0,
      folderMap: [],
      modalKeyShare: 0,
      totalCount: 0,
      documentsToShare: [],
      operationId: this.$route.params.operationId,
      allowCreate: this.$store.getters.isEstateAgent || this.$store.getters.isCollaborator || this.$store.getters.isCollaboratorPlus,
      allowEdit: this.$store.getters.isEstateAgent || this.$store.getters.isCollaborator || this.$store.getters.isCollaboratorPlus,
      allowDelete: this.$store.getters.isEstateAgent || this.$store.getters.isCollaborator || this.$store.getters.isCollaboratorPlus,
      operationName: null,
      selectedDocument: null
    }
  },

  computed: {
    tableFields() {
      return [
        {
          key: 'selected',
          sortable: false
        },
        {
          label: this.$t('OperationDocument.name'),
          key: 'name',
          sortable: true
        },
        {
          label: this.$t('OperationDocument.folder'),
          key: 'folder',
          sortable: true
        },
        {
          label: this.$t('OperationDocument.lot'),
          key: 'lot',
          sortable: false
        },
        {
          label: this.$t('OperationDocument.validity'),
          key: 'validity',
          sortable: false
        },
        {
          label: this.$t('OperationDocument.deadlineDate'),
          key: 'deadlineDateFormat',
          sortable: false
        },
        {
          label: '',
          key: 'actions'
        }]
    }
  },

  async mounted() {
    this.operationId = this.$route.params.operationId
    this.getFolderMap()
    if(this.operationId){
      await this.fetchOperation()
    }
    this.$refs.B122TableOperationDocument.refreshTable()
  },

  methods: {
    getExpiration(date) {
      let today = new Date()
      return (date - today) < 0
    },

    getTimeBetweenTodayAndDate(date) {
      let delay = 30 * 24 * 60 * 60 * 1000
      let today = new Date()
      return (date - today.getTime()) < delay
    },

    async fetchOperation() {
      await api
        .get(`/operation/${this.operationId}`)
        .then(response => {
          this.operationName = response.data.name
        })
    },

    setTotalCount(totalCount) {
      this.totalCount = totalCount
    },

    clickOnCreateBtn() {
      this.$router.push({
        name: 'OperationDocumentCreate',
        params: {
          operationId: this.operationId
        }
      })
    },

    clickOnDownloadBtn(row) {
      let fileUrl = row.item.file.fileUrl
      let url = process.env.SERVER_URL + fileUrl
      window.open(url, '_blank').focus();
    },

    clickOnEditBtn(row) {
      this.$router.push({
        name: 'OperationDocumentEdit',
        params: {
          operationDocumentId: row.item.id,
          operationId: this.operationId
        }
      })
    },

    clickOnDeleteDocumentBtn(row) {
      this.selectedDocument = row.item
      this.$bvModal.show('document-delete-modal')
    },

    didDeleteDocument() {
      this.selectedDocument = null
      this.$refs.B122TableOperationDocument.refreshTable()
    },

    onRowSelected(items) {
      this.documentsToShare = items
    },

    shareDocuments() {
      this.modalKeyShare += 1
      if (this.documentsToShare.length > 0) {
        this.$bvModal.show('share-document-modal')
      }
    },

    showAllLinks() {
      this.$router.push({
        name: 'OperationShowAllLinks',
        params: {
          operationId: this.operationId
        }
      })
    },

    clickOnAddFolderBtn() {
      this.$bvModal.show('add-folder-modal')
    },

    clickOnEditFolderBtn(folder) {
      this.editFolder = folder
      this.editFolderKey++
      setTimeout(() => this.$bvModal.show('edit-folder-modal'), 500);

    },

    clickOnDeleteFolderBtn(folder) {
      this.deleteFolder = folder
      this.$bvModal.show('delete-folder-modal')
    },

    getFolderMap() {
      api.get('/operationDocument/getOperationFolders/' + this.operationId).then(response => {
        this.mapLength = 5 - (response.data.length % 5)
        this.folderMap = this.splitArray(response.data, 5)
      });
    },

    splitArray(input, spacing) {
      var output = [];

      for (var i = 0; i < input.length; i += spacing) {
        output[output.length] = input.slice(i, i + spacing);
      }

      return output;
    },

    didAddFolder() {
      this.getFolderMap()
      this.$refs.B122TableOperationDocument.refreshTable()
    },

    filterByFolder(folderId) {
      if (this.selectedFolder === folderId) {
        this.selectedFolder = 0
      } else {
        this.selectedFolder = folderId
      }
      this.$refs.B122TableOperationDocument.refreshTable()
    }
  }
}
</script>

<style scoped>
.border-grey {
  border: 1px solid var(--main-grey);
  padding: 15px;
  background-color: #FFFFFF;
}

.download-btn {
  padding: 2px 6px;
  border-color: var(--main-color);
  color: var(--main-color);
  background-color: transparent;
  font-family: "Montserrat-Bold", "Arial", sans-serif;
  border-radius: var(--main-border-radius);
  border-width: 2px;
  justify-content: center;
  align-items: center;
}

/* États du folder */
.folder-fixed {
  height: 50px;
  background: white;
  border: 1px solid #6D84C4;
  border-radius: 8px;
  cursor: pointer;
  position: relative;
}

.folder-fixed-selected {
  height: 50px;
  background: #6D84C4;
  border: 1px solid #6D84C4;
  border-radius: 8px;
  cursor: pointer;
  position: relative;
}

.folder-title {
  color: var(--main-text-color);
  font-size: 14px;
  font-family: "Montserrat-Bold", "Arial", sans-serif;
}

/* Grille responsive */
.folder-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  grid-gap: 12px;
}

/* Card */
.folder-card {
  height: 50px;
  border-radius: 8px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative; /* pour placer les actions en haut à droite */
}

/* Contenu centré */
.folder-left {
  display: flex;
  align-items: center;
  min-width: 0; /* obligatoire pour text-overflow */
}

/* Texte du dossier */
.folder-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 150px; /* largeur max ajustable */
  font-size: 14px;
  font-family: "Montserrat-Bold", "Arial", sans-serif;
}

/* Actions en haut à droite */
.folder-actions-top {
  position: absolute;
  top: 4px;
  right: 6px;
  display: flex;
  align-items: center;
  gap: 4px;
}




</style>



// WEBPACK FOOTER //
// src/views/operation/OperationShowTabs/OperationShowDocuments.vue